// @flow

import * as React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { Card, FormControl, HiddenInput, Text, View } from 'reshaped';

import { Badge } from '@gandi/reshaped';

import { useTranslator } from '@gandi/translate';

import { Offer } from './Offer';

export function Offers(): React.MixedElement {
  const { __ } = useTranslator();

  const { control, setValue, register } = useFormContext();

  const items = React.useMemo(
    () => [
      {
        label: __('Domain Validation'),
        provider: 'sectigo',
        validation_type: 'dv',
        children: __(
          'Valid exclusively for domains you control. Quick, fully automated issuance via the ACME protocol.',
        ),
      },
      {
        label: __('Organization Validation'),
        validation_type: 'ov',
        provider: 'sectigo',
        children: __(
          'Validates domain ownership and your organization’s legal existence. Additional verification required before certificate issuance.',
        ),
        disabled: true,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <View>
      <FormControl>
        <FormControl.Label>
          <Text
            as="h2"
            variant="body-2"
            weight="bold"
            attributes={{ style: { marginBottom: 'var(--rs-unit-x3)' } }}
          >
            {__('Subscription type')}
          </Text>
        </FormControl.Label>
        <Controller
          name="validation_type"
          control={control}
          rules={{ required: __('This field is required') }}
          render={({ field, fieldState }) => (
            <>
              <View direction={{ m: 'row' }} gap={4} align="stretch">
                {items.map(({ validation_type: type, disabled, ...item }) => (
                  <View grow key={type} position="relative">
                    <Card
                      as={disabled ? 'div' : 'label'}
                      selected={field.value === type}
                      padding={0}
                      height="100%"
                      attributes={{
                        style: {
                          boxShadow:
                            field.value === type
                              ? '0 0 0 1px var(--rs-color-border-primary)'
                              : undefined,
                          cursor: disabled ? 'not-allowed' : 'pointer',
                          opacity: disabled ? '0.5' : undefined,
                        },
                        title: disabled ? __('Coming soon') : undefined,
                      }}
                    >
                      {!disabled && (
                        <HiddenInput
                          name={field.name}
                          type="radio"
                          value={type}
                          checked={field.value === type}
                          onChange={() => {
                            React.startTransition(() => {
                              field.onChange(type);
                              setValue('provider', item.provider);
                            });
                          }}
                        />
                      )}
                      <Offer type={type} {...item} />
                    </Card>
                    {disabled && (
                      <View position="absolute" insetTop={3} insetEnd={3}>
                        <Badge color="informative">{__('Coming soon')}</Badge>
                      </View>
                    )}
                  </View>
                ))}
              </View>

              {fieldState.error && (
                <Text color="critical" variant="body-3">
                  {fieldState.error.message}
                </Text>
              )}
            </>
          )}
        />
      </FormControl>
      <input type="hidden" {...register('provider')} />
    </View>
  );
}
